(function(){
var rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('.lir').forEach(function(w){var s=w.querySelectorAll('svg'),i=0,paused=false;if(rm||s.length<2)return;
w.parentElement.addEventListener('mouseenter',function(){paused=true});w.parentElement.addEventListener('mouseleave',function(){paused=false});
setInterval(function(){if(paused)return;s[i].classList.remove('on');i=(i+1)%s.length;s[i].classList.add('on');w.setAttribute('aria-label','Compact Care — for '+s[i].dataset.l)},3800)});
document.querySelectorAll('[data-dd]').forEach(function(d){var b=d.querySelector('button');function set(o){d.classList.toggle('open',o);b.setAttribute('aria-expanded',o)}
d.addEventListener('mouseenter',function(){set(true)});d.addEventListener('mouseleave',function(){set(false)});b.addEventListener('click',function(){set(!d.classList.contains('open'))});
d.addEventListener('keydown',function(e){if(e.key==='Escape'){set(false);b.focus()}});d.addEventListener('focusout',function(e){if(!d.contains(e.relatedTarget))set(false)})});
var p=document.getElementById('cc-popup');
if(p&&/[?&]customer_posted=true|#popup-signup/.test(location.href)){p.hidden=false}
})();
/* One mobile-menu owner. Leave anchors native, including Shopify preview URLs. */
(function(){
var mm=null,section=null,opener=null,overflow='';
function set(open,restore){if(!mm)return;
if(open&&mm.hidden){overflow=document.body.style.overflow;opener=document.activeElement;}
mm.hidden=!open;document.body.style.overflow=open?'hidden':overflow;
document.querySelectorAll('[data-menu]').forEach(function(b){b.setAttribute('aria-expanded',String(open));});
if(open){var close=mm.querySelector('[data-menu]');close&&close.focus();}
else if(restore&&opener&&opener.isConnected)opener.focus();
}
function init(){var menus=document.querySelectorAll('#mobile-menu'),next=menus[menus.length-1];if(!next||next===mm)return;
if(mm){set(false,false);mm.remove();}
mm=next;section=mm.closest('.shopify-section');document.body.appendChild(mm);
}
init();
document.addEventListener('click',function(e){var t=e.target.closest('[data-menu]');if(!t||!mm)return;e.preventDefault();set(mm.hidden,true);});
document.addEventListener('keydown',function(e){if(!mm||mm.hidden)return;
if(e.key==='Escape'){e.preventDefault();set(false,true);return;}
if(e.key!=='Tab')return;
var nodes=Array.from(mm.querySelectorAll('a[href],button:not([disabled]),summary')).filter(function(n){return n.getClientRects().length;});
var first=nodes[0],last=nodes[nodes.length-1];
if(e.shiftKey&&document.activeElement===first){e.preventDefault();last&&last.focus();}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first&&first.focus();}
});
document.addEventListener('shopify:section:load',init);
document.addEventListener('shopify:section:unload',function(e){if(section!==e.target)return;set(false,false);mm&&mm.remove();mm=null;section=null;});
window.addEventListener('pageshow',function(){set(false,false);});
matchMedia('(min-width:1024px)').addEventListener('change',function(e){if(e.matches)set(false,true);});
})();
